module.exports = __webpack_public_path__ + "img/rex_at_water_fountain.b968ecdf.jpg";